export default __webpack_public_path__ + "static/4-control-statement-ea64cb70aea7e1099e8ba118b72ee387.png";